import { render } from "./CookiesConsent.vue?vue&type=template&id=3abb7d42&scoped=true"
import script from "./CookiesConsent.vue?vue&type=script&lang=js"
export * from "./CookiesConsent.vue?vue&type=script&lang=js"

import "./CookiesConsent.vue?vue&type=style&index=0&id=3abb7d42&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abb7d42"]])

export default __exports__